"use client";

import { Button } from "@/components";
import { getImageURL } from "@/lib";

export const BannerSpaceDivision = ({ data = {} }) => {
    return (
        <>
            <div className="banner__space"></div>
        </>
    );
};
